import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ClerkGate from './context/ClerkGate';
import { AuthProvider } from './context/AuthContext';
import PostBuilderPage from './pages/PostBuilderPage';
import AdminPanel from './pages/AdminPanel';
import AdminMigration from './pages/AdminMigration';
import AdminHealth from './pages/AdminHealth';
import AdminStorage from './pages/AdminStorage';
import AdminAnalytics from './pages/AdminAnalytics';
import AdminCleanup from './pages/AdminCleanup';
import AdminSchema from './pages/AdminSchema';
import AdminCarousels from './pages/AdminCarousels';
import AdminRenderDiagnostics from './pages/AdminRenderDiagnostics';
import AdminAuthBinding from './pages/AdminAuthBinding';
import TestGenArt from './pages/TestGenArt';

/**
 * Magic Forest Visuals
 * A carousel/post creation tool for Instagram-format content
 * https://visuals.magicforest.land
 *
 * Step 4: ClerkGate wraps AuthProvider.
 * When REACT_APP_USE_CLERK_AUTH=false (default): ClerkGate is a pure passthrough.
 * When true: ClerkGate loads ClerkProvider + ClerkTokenBridge (lazy).
 * ClerkTokenBridge injects getToken into authHeaders before AuthProvider mounts.
 */
function App() {
  return (
    <ClerkGate>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PostBuilderPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin/migration" element={<AdminMigration />} />
            <Route path="/admin/health" element={<AdminHealth />} />
            <Route path="/admin/storage" element={<AdminStorage />} />
            <Route path="/admin/analytics" element={<AdminAnalytics />} />
            <Route path="/admin/cleanup" element={<AdminCleanup />} />
            <Route path="/admin/carousels" element={<AdminCarousels />} />
            <Route path="/admin/schema" element={<AdminSchema />} />
            <Route path="/admin/render-diagnostics" element={<AdminRenderDiagnostics />} />
            <Route path="/admin/auth-binding" element={<AdminAuthBinding />} />
            <Route path="/test-genart" element={<TestGenArt />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ClerkGate>
  );
}

export default App;
